import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../providers/withRouter";
import { BsSearch } from "react-icons/bs";
import { ImCross } from "react-icons/im";
import provinces from "@doncicuto/es-provinces";
import municipalities from "@doncicuto/es-municipalities";
import {
  cambiarFormatoNombre,
  municipiosIniciales,
} from "../../functions/funciones";
import {
  getAllConsultores,
  listCosultor,
  getConsultores,
  getServicios,
} from "../../services";
import {
  ordenarNombreYApellido,
  ordenarProvinciasYMunicipios,
} from "../../functions/ordenarListas";
import {
  Box,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
  FormControlLabel,
} from "@mui/material";
import { CustomSwitch } from "../Buttons/Switch";
import { UsuarioContext } from "../../providers/userContext";
import SearchProgresState from "./SearchProgresState";
import { useLocation } from "react-router-dom";

const FiltrosProveedores = ({
  onFilter,
  clearFilter,
  filtrosIniciales,
  // clean,
}) => {
  const { t } = useTranslation('common');
  const user = useContext(UsuarioContext);
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [listadoMunicipios, setListadoMunicipios] = useState([]);
  const [consultor, setConsultor] = useState([]);
  const [sinConsul, setSinConsul] = useState(false);
  const [estados, setEstados] = useState([]);
  const [servicios, setServicios] = useState([]);

  const location = useLocation();

  // useEffect(() => {
  //   if (clean) {
  //     clearAllFilters();
  //   }
  // }, [clean]);

  useEffect(() => {
    getDatas();
  }, []);

  useEffect(() => {
    setListadoMunicipios(
      municipiosIniciales(provinces, municipalities, busqueda.provincia)
    );
  }, [busqueda]);

  useEffect(() => {
    // Combinar la carga inicial de usuario con los filtros de URL
    if (user.rol === "CONSUL" && sinConsul == false) {
      setBusqueda((prevBusqueda) => ({
        ...prevBusqueda,
        consul_id: user.id,
      }));
    }
    localStorage.setItem("hasReloaded", "false");
  }, []);

  const cargarUser = () => {
    if (user.rol === "CONSUL" && sinConsul == false) {
      setBusqueda((prevBusqueda) => ({
        ...prevBusqueda,
        consul_id: user.id,
      }));
    }
    localStorage.setItem("hasReloaded", "false");
  };

  useEffect(() => {
    if (localStorage.getItem("hasReloaded") === "true") {
      clearAllFilters();
      cargarUser();
      localStorage.setItem("hasReloaded", "false");
    }
  }, [location]);

  const clearAllFilters = () => {
    setSinConsul(false);
    if (typeof clearFilter === "function") {
      clearFilter();
    }
    if (user.rol === "CONSUL") {
      setBusqueda({
        consul_id: user.id,
      });
    } else {
      setBusqueda({});
    }

    cargarUser();
  };
  const getDatas = async () => {
    const estados = JSON.parse(localStorage.getItem("statesSupps")) || [];
    setEstados(estados);
    const servicios = await getServicios();
    setServicios(servicios.data);
    const consul =
      user.rol === "CONSUL"
        ? await getConsultores({ filtros: { id: user.id } })
        : [];

    if (user.rol === "CONSUL" && consul.data?.length > 0) {
      setBusqueda({
        ...busqueda,
        consul_id: user.id,
      });

      setConsultor(ordenarNombreYApellido(consul.data));
    }
  };

  const seleccionarMunicipios = (e) => {
    let codProvincia = "";
    let municipios = [];
    provinces.map((p) => {
      if (p.name === e.target.value) {
        codProvincia = p.code;
      }
    });
    if (e.target.name === "provincia" || e.target.value === "") {
      setBusqueda({
        ...busqueda,
        [e.target.name]: e.target.value,
        municipio: "",
      });
    } else {
      setBusqueda({
        ...busqueda,
        [e.target.name]: e.target.value,
      });
    }
    municipalities.map((m) => {
      if (m.provCode === codProvincia) {
        municipios.push({
          ...m,
          name: cambiarFormatoNombre(m.name),
          value: m.name,
        });
      }
    });
    setListadoMunicipios(municipios);
  };

  const handleAsynchronousChange = (name, selectedValue) => {
    setBusqueda({
      ...busqueda,
      [name]: selectedValue?.id,
    });
  };

  const busquedaInput = (name, valorBusqueda) => {
    if (
      name === "consul_id" &&
      user.rol !== "AAFF" &&
      (busqueda.consul_id !== undefined || valorBusqueda)
    ) {
      listCosultor({
        filtros: {
          nombreA: valorBusqueda,
        },
        params: {},
      }).then((res) => {
        setConsultor(ordenarNombreYApellido(res.data));
      });
    }
  };

  function handleChange(evt) {
    const value = evt.target.value;
    setBusqueda({
      ...busqueda,
      [evt.target.name]: value,
    });
  }

  function handleBooleanChange(evt) {
    const value = evt.target.value;
    const boolValue = value === "" ? undefined : value === "true" || value === true;
    setBusqueda({
      ...busqueda,
      [evt.target.name]: boolValue,
    });
  }

  const getBusqueda = () => {
    for (let key in busqueda) {
      if (typeof busqueda[key] === 'boolean') {
        continue;
      }
      if (
        busqueda[key] === "" ||
        busqueda[key] === null ||
        busqueda[key] === undefined
      ) {
        delete busqueda[key];
      }
    }
    if (busqueda.consul_id == undefined) {
      setSinConsul(true);
    }

    onFilter(busqueda);
  };

  return (
    <>
      <div className="buscadorFiltros">
        <div style={{ width: "100%" }}>
          <Box mx={1} display={"block"} flexDirection={"row"} gap={2}>
            <TextField
              id="razonSocial-input"
              label={t('filters.businessName')}
              variant="outlined"
              name="razonSocial"
              className="filtros altura"
              value={busqueda.razonSocial || ""}
              onChange={handleChange}
              onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              inputProps={{
                "aria-label": "controlled",
              }}
            />
            {user.rol !== "AAFF" && (
              <>
                <TextField
                  id="nif-input"
                  label={t('filters.nif')}
                  variant="outlined"
                  name="nif"
                  className="filtros altura"
                  value={busqueda.nif || ""}
                  onChange={handleChange}
                  onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                  inputProps={{
                    "aria-label": "controlled",
                  }}
                />
                <TextField
                  id="email-input"
                  label={t('filters.email')}
                  variant="outlined"
                  name="emailContacto"
                  className="filtros altura"
                  value={busqueda.emailContacto || ""}
                  onChange={handleChange}
                  onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                  inputProps={{
                    "aria-label": "controlled",
                  }}
                />
                <TextField
                  id="email-input"
                  label={t('filters.phone')}
                  variant="outlined"
                  name="telefonoContacto"
                  className="filtros altura"
                  value={busqueda.telefonoContacto || ""}
                  onChange={handleChange}
                  onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                  inputProps={{
                    "aria-label": "controlled",
                  }}
                />
              </>
            )}
            <FormControl variant="outlined" className="filtros-select">
              <InputLabel id="provincia-label">{t('filters.province')}</InputLabel>
              <Select
                labelId="provincia-label"
                id="province-select"
                label={t('filters.province')}
                name="provincia"
                className="filtros"
                value={busqueda.provincia || ""}
                onChange={seleccionarMunicipios}
                onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              >
                <MenuItem value="" style={{ height: 40 }}></MenuItem>
                {provinces.sort(ordenarProvinciasYMunicipios)?.map((e, i) => {
                  return (
                    <MenuItem key={i} value={e.name}>
                      {e.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <FormControl variant="outlined" className="filtros-select">
              <InputLabel id="municipio-label">{t('filters.municipalities')}</InputLabel>
              <Select
                labelId="municipio-label"
                id="municipio-select"
                label={t('filters.municipality')}
                name="municipio"
                className="filtros"
                value={busqueda?.municipio || ""}
                onChange={handleChange}
                onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              >
                <MenuItem value="" style={{ height: 40 }}></MenuItem>
                {listadoMunicipios
                  .sort(ordenarProvinciasYMunicipios)
                  ?.map((e, i) => {
                    return (
                      <MenuItem key={i} value={e.name}>
                        {e.name}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
            {user.rol !== "AAFF" && (
              <FormControl variant="outlined" className="filtros-select">
                <SearchProgresState
                  labelId="consultor-label"
                  id="consultor-select"
                  label={t('filters.consultant')}
                  name="consul_id"
                  className="filtros"
                  tipo="nombre"
                  array={consultor}
                  onOptionSelected={handleAsynchronousChange}
                  busquedaInput={busquedaInput}
                  valueOnLoad={consultor.find(
                    (c) => c.id === busqueda.consul_id
                  )}
                />
              </FormControl>
            )}
            <FormControl variant="outlined" className="filtros-select">
              <InputLabel id="source-label">{t('filters.source')}</InputLabel>
              <Select
                labelId="source-label"
                id="source-select"
                label={t('filters.source')}
                name="source"
                className="filtros"
                value={busqueda?.source || ""}
                onChange={handleChange}
                onKeyPress={(e) =>
                  e.key === "Enter" ? getBusqueda() : ""
                }
              >
                <MenuItem value="" style={{ height: 40 }}></MenuItem>
                <MenuItem value={"taaf"}>
                  {"taaf"}
                </MenuItem>
              </Select>
            </FormControl>
            {(user.rol === "ADMIN" || user.rol === "CONSUL" || user.rol === "VENT") && (
              <>
                <FormControl variant="outlined" className="filtros-select">
                  <InputLabel id="hasPendingDocs-label">{t('filters.pendingDocsValidation')}</InputLabel>
                  <Select
                    labelId="hasPendingDocs-label"
                    id="hasPendingDocs-select"
                    label={t('filters.pendingDocsValidation')}
                    name="hasPendingDocs"
                    className="filtros"
                    value={busqueda?.hasPendingDocs !== undefined ? String(busqueda.hasPendingDocs) : ""}
                    onChange={handleBooleanChange}
                    onKeyPress={(e) =>
                      e.key === "Enter" ? getBusqueda() : ""
                    }
                  >
                    <MenuItem value="" style={{ height: 40 }}></MenuItem>
                    <MenuItem value="true">{t('filters.yes')}</MenuItem>
                    <MenuItem value="false">{t('filters.no')}</MenuItem>
                  </Select>
                </FormControl>
                <FormControl variant="outlined" className="filtros-select">
                  <InputLabel id="estado_id-label">{t('filters.stateSupps')}</InputLabel>
                  <Select
                    labelId="estado_id-label"
                    id="estado_id-select"
                    label={t('filters.stateSupps')}
                    name="estado_id"
                    className="filtros"
                    value={ busqueda.estado_id || "" }
                    onChange={handleChange}
                    onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                  >
                    <MenuItem value="" style={{ height: 40 }}></MenuItem>
                    {estados.map((e, i) => {
                      return (
                        <MenuItem key={i} value={e.id}>
                          {t(`stateSupps.${e.nombre}`, e.nombre)}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <FormControl variant="outlined" className="filtros-select">
                  <InputLabel id="standBy-label">{t('filters.standBy')}</InputLabel>
                  <Select
                    labelId="standBy-label"
                    id="standBy-select"
                    label={t('filters.standBy')}
                    name="standBy"
                    className="filtros"
                    value={busqueda?.standBy ?? ""}
                    onChange={handleBooleanChange}
                    onKeyPress={(e) =>
                      e.key === "Enter" ? getBusqueda() : ""
                    }
                  >
                    <MenuItem value="" style={{ height: 40 }}></MenuItem>
                    <MenuItem value={false}>
                      {"NO"}
                    </MenuItem>
                    <MenuItem value={true}>
                      {"SÍ"}
                    </MenuItem>
                  </Select>
                </FormControl>
              </>
              
            )}
            {(user.rol !== "TECH" && user.rol !== "TECH_COOR" && user.rol !== "AAFF") && (
              <>
                <FormControl variant="outlined" className="filtros-select">
                  <InputLabel id="servicio-label">{t('filters.serviceSupps')}</InputLabel>
                  <Select
                    labelId="servicio-label"
                    id="servicio-select"
                    label={t('filters.serviceSupps')}
                    name="servicio_id"
                    className="filtros"
                    value={ busqueda.servicio_id || "" }
                    onChange={handleChange}
                    onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                  >
                    <MenuItem value="" style={{ height: 40 }}></MenuItem>
                    {servicios.map((e, i) => {
                      return (
                        <MenuItem key={i} value={e.id}>
                          {t(`serviceSupps.${e.nombre}`, e.nombre)}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                
              </>
              
            )}
            <FormControlLabel
              sx={{ height: 50, margin: '5px 5px', verticalAlign: 'middle' }}
              control={
                <CustomSwitch
                  name="sinDocumentos"
                  checked={!!busqueda.sinDocumentos}
                  onChange={(e) => {
                    const updated = { ...busqueda };
                    if (e.target.checked) {
                      updated.sinDocumentos = true;
                    } else {
                      delete updated.sinDocumentos;
                    }
                    setBusqueda(updated);
                    onFilter(updated);
                  }}
                />
              }
              label={t('filters.noDocs')}
            />
          </Box>
        </div>
        <div>
          <Button className="btn-buscador" onClick={clearAllFilters}>
            <ImCross />
          </Button>
        </div>
        <div>
          <Button className="btn-buscador" onClick={() => getBusqueda()}>
            <BsSearch />
          </Button>
        </div>
      </div>

      <style jsx="true">
        {`
          .btn-buscador {
            padding: 5px 10px;
            color: #ffffff;
            background-color: #92004d;
            border-radius: 4px;
            font-weight: bold;
            width: -moz-fit-content;
            width: fit-content;
            align-self: flex-end;
            border: none;
            min-width: 40px;
            height: 40px;
            margin: 5px 10px 5px;
          }
          .btn-buscador:hover {
            color: black;
            background-color: #dee2e6;
          }
        `}
      </style>
    </>
  );
};

export default withRouter(FiltrosProveedores);
